import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetSharedPublicPostQuery } from '@/api/client';
import { EventDetailScreen } from '@feature/event-detail/EventDetailScreen';
import { EventPost } from '@feature/event-detail/types';

export default function EventDetailPage(): React.ReactElement {
  const { eventId: shareId } = useParams<{ eventId: string }>();

  const {
    data: post,
    isLoading,
    error,
  } = useGetSharedPublicPostQuery(shareId || '', {
    skip: !shareId,
  });

  if (!shareId) {
    return (
      <div style={styles.errorContainer}>
        <h1>Invalid Event Link</h1>
        <p>The event link appears to be invalid.</p>
        <a href="/download">Download the Hereabout App</a>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div style={styles.loadingContainer}>
        <div style={styles.loadingSpinner}>Loading event...</div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div style={styles.errorContainer}>
        <h1>Event Not Found</h1>
        <p>This event may be private or no longer available.</p>
        <a href="/download">Download the Hereabout App</a>
      </div>
    );
  }

  if (post.post_type !== 'event') {
    return (
      <div style={styles.errorContainer}>
        <h1>Not an Event</h1>
        <p>This link does not point to an event.</p>
        <a href="/download">Download the Hereabout App</a>
      </div>
    );
  }

  return <EventDetailScreen event={post as EventPost} />;
}

const styles: Record<string, React.CSSProperties> = {
  errorContainer: {
    minHeight: 'calc(var(--vh, 1vh) * 100)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    textAlign: 'center',
  },
  loadingContainer: {
    minHeight: 'calc(var(--vh, 1vh) * 100)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingSpinner: {
    fontSize: '16px',
    color: '#666',
  },
};
